import { useCallback, useEffect, useMemo, useState } from 'react';
import { cachedHistory, requestHistory } from './paddockHistoryClient';

export default function usePaddockHistorySummary(raceId, enabled) {
  const [state, setState] = useState({ raceId: '', status: 'idle', data: null });
  const [reload, setReload] = useState(0);
  useEffect(() => {
    if (!enabled || !raceId) return;
    const params = { race_id: raceId, mode: 'summary' };
    const cached = cachedHistory(params);
    if (cached) { setState({ raceId, status: 'ready', data: cached }); return; }
    let current = true, operation;
    setState({ raceId, status: 'loading', data: null });
    // Defer until the diagnosis screen has painted. No dependency in its loading path.
    const timer = setTimeout(() => {
      if (!current) return;
      operation = requestHistory(params);
      operation.response.then(data => {
        if (current) setState({ raceId, status: 'ready', data });
      }).catch(error => {
        if (!current) return;
        const missing = error.response?.statusCode === 404 || error.response?.status === 404;
        setState({ raceId, status: missing ? 'missing' : 'error', data: null });
      });
    }, 1000);
    return () => { current = false; clearTimeout(timer); operation?.cancel(); };
  }, [raceId, enabled, reload]);
  const retry = useCallback(() => setReload(n => n + 1), []);
  return useMemo(() => ({ ...(state.raceId === raceId ? state : { status: 'idle', data: null }), retry }), [state, raceId, retry]);
}
